import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import './Auth.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token. Open the link from your email, or request a new one from the login page.');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/auth/verify-email', { params: { token } });
        if (!cancelled) {
          setStatus('ok');
          setMessage(data.message || 'Your email is verified.');
        }
      } catch (err) {
        if (!cancelled) {
          setStatus('error');
          setMessage(err.response?.data?.error || 'Verification failed.');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1 className="auth-title">Email verification</h1>
        </div>
        {status === 'loading' && <p className="auth-subtitle">Verifying…</p>}
        {status === 'ok' && <div className="auth-success">{message}</div>}
        {status === 'error' && <div className="auth-error">{message}</div>}
        <div className="auth-footer" style={{ marginTop: '1.5rem' }}>
          <p><Link to="/login" className="auth-link">Go to login</Link></p>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
